
import Map from 'ol/Map';
import * as ol_style from 'ol/style';
import ol_source_TileWMS from 'ol/source/TileWMS';
import ol_layer_Tile from 'ol/layer/Tile';

import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import { Vector as ol_layer_Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import { Point as ol_geom_Point } from 'ol/geom';
import MultiPoint from 'ol/geom/MultiPoint';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';
import { FrCoordinate, FrLayer, OlMapBaseComponent } from 'gmap';
import { SupervisionError, Panel, IssueType, IssueImage } from 'solar-bo';

import { OlObjectTypeEnum } from 'solar-bo';
import { environment } from 'projects/solarapp/src/environments/environment';
import { mapcte } from 'gmap';
import { IssueTypeHelper } from '@solar/solar/models/IssueTypeHelper.model';
import { AppConfig } from '@solar/app.config';

export class MapSupervisionHelper {


  // map:Map;
  constructor() {
    //   this.map=mapc.map;
  }


  static issuePolygonDraw(issue: SupervisionError, parentLayer: any, locator_patern: string = "", functionStyle: boolean=false): Feature {
    try {
      let panel=issue.info.panel;
      if(!panel){
        return;
      }
      let locatorDesc = MapSupervisionHelper.locatorGetFormatedDescByPattern(panel, locator_patern);

      const layerExt = new FrLayer(locatorDesc, issue.id);
      layerExt.ref = OlObjectTypeEnum.issue;
      layerExt.refObject = issue;
      if (!panel.geom){
        throw new Error("There is no panel geom for issue id: " +issue.id);
      }
      let poly = panel.geom.coordinates[0];
      const polygon = new Polygon([poly]);
      // Create feature with polygon.
      let point = new ol_geom_Point(poly[0]);
      const feature = new Feature({ geometry: polygon, labelPoint: point, name: locatorDesc });
      feature[mapcte.frlayerinfo_FieldName] = layerExt;
      feature.setId(issue.id);

      if (!functionStyle) {
        let panelFill = new Fill({
          color: 'rgba(220, 53, 53, 0.2)'
        });
        
        let stroke = new ol_style.Stroke({
          color: this.issueGetErrorTypeColor(issue.type),
          width: 2
        });

        let styles = [
          new ol_style.Style({
            stroke: stroke,
            fill: panelFill
          })
        ];
        feature.setStyle(styles);
      }
      else{
        //style is set at layer level
      }
     

      if (parentLayer) {
        parentLayer.getSource().addFeature(feature);
      }
      return feature;
    }
    catch (err) {
      //console.log(err);
    }
  }

  static locatorGetFormatedDescByPattern(panel: Panel, locator_patern: string = ""): string {
    let locatorDesc = SupervisionError.uiLocatorByPanel(panel, locator_patern);
    return locatorDesc;
  }


  /**
   * Draw a panel without any special format or color
   * @param panel 
   * @param parentLayer 
   * @param locator_patern 
   */
  static panelPolygonDraw(panel: Panel, parentLayer: any, locator_patern: string = ""): Feature {
    try {
      let locatorDesc = MapSupervisionHelper.locatorGetFormatedDescByPattern(panel, locator_patern);

      const layerExt = new FrLayer(locatorDesc, panel.id);
      layerExt.ref = OlObjectTypeEnum.panel;
      layerExt.refObject = panel;
      let poly = panel.geom.coordinates[0];
      const polygon = new Polygon([poly]);
      // Create feature with polygon.
      let point = new ol_geom_Point(poly[0]);
      const feature = new Feature({ geometry: polygon, labelPoint: point, name: locatorDesc });
      feature[mapcte.frlayerinfo_FieldName] = layerExt;
      feature.setId(panel.id);

      let panelFill = new Fill({
        color: 'rgba(220, 53, 53, 0.1)'
      });

      let stroke = new ol_style.Stroke({
        color: 'rgb(23, 203, 248)',
        width: 1
      });

      let styles = [
        new ol_style.Style({
          stroke: stroke,
          fill: panelFill
        })
      ];

      feature.setStyle(styles);

      if (parentLayer) {
        parentLayer.getSource().addFeature(feature);
        //parentLayer.setStyle(styles);
      }
      return feature;
    }
    catch (err) {
      console.log(err);
    }
  }

  /* 
  static panelPolygonDraw(panel: Panel, parentLayer: any, locator_patern:string=""): Feature {
    try {
      let locatorDesc =MapSupervisionHelper.locatorGetFormatedDescByPattern(panel,locator_patern);
   */

  static issuePolygonDrawNoStyle(issue: SupervisionError, parentLayer: any, locator_patern: string = ""): Feature {
    try {
      if (!issue){
        return;
      }
      let panel = issue.info.panel;
      if (!panel){
        return;
      }
      let locatorDesc = MapSupervisionHelper.locatorGetFormatedDescByPattern(panel, locator_patern);

      const layerExt = new FrLayer(locatorDesc, issue.id);
      layerExt.ref = OlObjectTypeEnum.issue;
      layerExt.refObject = issue;
      let poly = panel.geom.coordinates[0];
      const polygon = new Polygon([poly]);
      // Create feature with polygon.
      let point = new ol_geom_Point(poly[0]);
      const feature = new Feature({ geometry: polygon, labelPoint: point, name: locatorDesc });
      feature[mapcte.frlayerinfo_FieldName] = layerExt;
      feature.setId(issue.id);

      if (parentLayer) {
        parentLayer.getSource().addFeature(feature);
      }
      return feature;
    }
    catch (err) {
      console.log(err);
    }
  }
  /**
   * create the feature and add to layer if passed
   * @param flightImage 
   * @param parentLayer 
   */
  static imagePolygonDrawNoStyle(flightImage: IssueImage, parentLayer: any=null, functionStyle: boolean=false): Feature {
    try {
      if (!flightImage){
        return;
      }

      if (flightImage.geom_polygon==null){
        return;
      }

      let locatorDesc = flightImage.name;
      const layerExt = new FrLayer(locatorDesc, flightImage.id);
      layerExt.ref = OlObjectTypeEnum.flightimageproj;
      layerExt.refObject = flightImage;
      let poly = flightImage.geom_polygon.coordinates[0];
      const polygon = new Polygon([poly]);
      // Create feature with polygon.
      let point = new ol_geom_Point(poly[0]);
      const feature = new Feature({ geometry: polygon, labelPoint: point, name: locatorDesc });
      feature[mapcte.frlayerinfo_FieldName] = layerExt;
      feature.setId(flightImage.id);
      if (!functionStyle){
        feature.setStyle(
          new ol_style.Style({
            stroke: new ol_style.Stroke({
              color: '#e4ff04',
              width: 1
            })
          })
        );        
      }


      if (parentLayer) {
        parentLayer.getSource().addFeature(feature);
      }
      return feature;
    }
    catch (err) {
      console.log(err);
    }
  }
  /**
   * Not used
   * @param issue 
   * @param polyFrLayer 
   * @param poly 
   * @param parentLayer 
   */
  panelPolygonDraw_notused(issue: SupervisionError, polyFrLayer: FrLayer, poly, parentLayer: any) {
    const polygon = new Polygon([poly]);
    // Create feature with polygon.
    let point = new ol_geom_Point(poly[0]);
    const feature = new Feature({ geometry: polygon, labelPoint: point, name: 'panel' });
    feature[mapcte.frlayerinfo_FieldName] = polyFrLayer;
    feature.setStyle(
      new ol_style.Style({
        stroke: new ol_style.Stroke({
          color: '#f44336',
          width: 1
        })
      })
    );
    parentLayer.getSource().addFeature(feature);
  }

  static issueGetErrorTypeColor(value: any): string {
    return IssueTypeHelper.issueGetErrorTypeColor(value);
  }

  static uiurlimg(issue: SupervisionError): string {
    return MapSupervisionHelper.issueUrlImgByIssue(issue);
  }
  static issueUrlImgByIssue(issue: SupervisionError): string {
    return MapSupervisionHelper.issueUrlImgByFullFields(issue.image.name, issue.supervision.site.id, issue.supervision.id, issue.flight.id);
  }

  static issueUrlImg(issue: SupervisionError, id_site: string, id_supervision: string): string {
    return MapSupervisionHelper.issueUrlImgByFullFields(issue.image.name, id_site, id_supervision, issue.flight.id);
    //"/images-supervision//supervisions/<suprvision_uuid>/output/thermal/images_rgb/<flight_uuid>/0000200_0148.jpg"
  }

  
  static issueUrlImgByFullFields(issueimagename: string, id_site: string, id_supervision: string, id_flight: string): string {
    return MapSupervisionHelper.FlightImageUrlByFullFields(issueimagename, id_site, id_supervision, id_flight);
  }

  static FlightImageUrlByFullFields(issueimagename: string, id_site: string, id_supervision: string, id_flight: string): string {
    let u = `/images-supervision/${id_site}/supervisions/${id_supervision}/output/thermal/images_rgb/${id_flight}/${issueimagename}.jpg`;
    u = environment.issueimagebasedir + u;
    return u;
  }

  static FlightImageThumbUrlByFullFields(imagename: string, id_site: string, id_supervision: string, id_flight: string): string {
    let u = `/images-supervision/${id_site}/supervisions/${id_supervision}/output/thermal/images_thumb/${id_flight}/${imagename}.jpg`;
    u = environment.issueimagebasedir + u;
    return u;
  }
  
    /**
   * show flight proyection images on map
   * @param mapComp 
   * @param visible 
   */
     static loadSupervisionProjectedImagesMap(mapComp:OlMapBaseComponent, visible: boolean = true,forceRefresh:boolean=false) {

      let frLayer=new FrLayer('Flight proyected images', 'Geoaitech_SupervisionImage');
      let layerExist=mapComp.layerGetByFrid(frLayer.id);
      if (layerExist) {
        if (forceRefresh==true){
          mapComp.layerRemove(frLayer.id);
        }
        else{
          return;
        }        
      }
    
      let gis_configuration=mapComp.gis_configuration;
      let source = new ol_source_TileWMS({
        url: gis_configuration.gis_server_url + gis_configuration.gis_base_service_raster_url,
        params: { 'LAYERS': gis_configuration.layers["supervision_images"] },
        projection: mapComp.projection
      })
  
      let layer = new ol_layer_Tile({
        source: source
      })
  
      layer.setMinZoom(19);
      layer.setVisible(visible);
  
      layer[mapcte.frlayerinfo_FieldName] = frLayer;
  
      mapComp.map.addLayer(layer);
    }

}